import React from 'react';
import { ColDef } from 'ag-grid-community';
import Big from 'bignumber.js';
import { Button } from 'semantic-ui-react';
import TradeLog from '../../../ts/models/TradeLog.model';
import { formatDateLocal, formatTimeLocal } from '../../../utils/time';

const tradeLogColDefs = ({
  isReadOnlyRole = false,
}: {
  isReadOnlyRole: boolean;
}): ColDef<TradeLog>[] => [
  { 
    headerName: 'Trade Date',
    field: 'date',
    valueFormatter: ({ data }) =>
      data?.reportDate
        ? formatDateLocal(data?.reportDate)
        : formatDateLocal(data?.date),
    headerClass: 'pull-left',
    width: 205,
    sortable: false,
    cellRenderer: 'agGroupCellRenderer',
  },
  {
    headerName: 'Exchange',
    field: 'exchangeMicCode',
    sortable: false,
  },
  {
    headerName: 'Product',
    field: 'productSymbol',
    sortable: false,
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Contract',
    field: 'contractSymbol',
    valueFormatter: ({ data }) => data?.clearingSymbol || '',
    sortable: false,
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Member Name',
    field: 'memberName',
    sortable: false,
  },
  {
    headerName: 'Account',
    field: 'accountId',
    valueFormatter: ({ data }) => data?.accountLabel || '',
    width: 150,
    sortable: false,
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Quantity',
    field: 'qty',
    cellClass: 'mono',
    sortable: false,
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Price',
    field: 'px',
    cellClass: 'mono',
    sortable: false,
    filter: 'agTextColumnFilter',
  },
  {
    headerName: 'Trade Type',
    field: 'tradeType',
    valueFormatter: ({ data }) => data?.tradeType || data?.trdType || '',
    sortable: false,
  },
  {
    headerName: 'Execution Time',
    field: 'execTime',
    width: 205,
    headerClass: 'pull-left',
    valueFormatter: ({ data }) => formatTimeLocal(data?.time),
    sortable: false,
  },
  {
    headerName: 'Report Time',
    field: 'reportTime',
    width: 205,
    headerClass: 'pull-left',
    valueFormatter: ({ data }) => formatTimeLocal(data?.reportTime),
    sortable: false,
  },
  {
    headerName: 'Aggressor',
    field: 'aggressor',
    sortable: false,
  },
  {
    headerName: 'Exchange Fee',
    field: 'exchange',
    cellClass: 'mono',
    valueFormatter: ({ data }) =>
      `${data?.exchangeFee || data?.exchangeFees || ''} ${data?.feeType || ''}`,
    sortable: false,
  },
  {
    headerName: 'Clearing Fee',
    field: 'clearingFee',
    cellClass: 'mono',
    sortable: false,
    valueFormatter: ({ data }) => {
      const feeClearing = data?.clearingFee || data?.clearingFees || 0;
      const feeClearingTotal = new Big(feeClearing)
        .plus(data?.deliveryFee || 0)
        .toFixed();
      return `${feeClearingTotal} ${data?.feeType || ''}`;
    },
  },
  {
    headerName: 'Spread ID',
    field: 'secondaryExecId',
    filter: 'agTextColumnFilter',
    sortable: false,
  },
  {
    headerName: 'Submitter',
    field: 'submitter',
    sortable: false,
  },
  {
    headerName: 'Trade Id',
    field: 'tradeId',
    filter: 'agTextColumnFilter',
    sortable: false,
  },
  {
    headerName: 'CAR',
    field: 'customerAccountRef',
    sortable: false,
  },
  {
    headerName: 'CTI',
    field: 'cti',
    sortable: false,
  },
  {
    headerName: 'Origin',
    field: 'origin',
    sortable: false,
  },
  {
    headerName: 'Reversal',
    field: 'reversal',
    sortable: false,
    cellRenderer: ({ data }: { data?: TradeLog }) => (
      <Button
        disabled={!!data?.reversalUuid || isReadOnlyRole}
        circular
        className="reversalButton"
        size="mini"
        icon="undo"
        color="red"
        content={`Reverse${data?.reversalUuid ? 'd' : ''}`}
      />
    ),
    width: 150,
  },
];

export default tradeLogColDefs;
